module.exports = __webpack_public_path__ + "img/footer-logo-title.0dd3c38f.png";